usuario.component('usuario.usuarioComponent', {
    templateUrl: 'usuario/usuario.html',
    controller: 'usuario.usuarioController'
});

usuario.controller('usuario.usuarioController', ['$scope', '$state', 'coreFb', 'coreLanguage', function($scope, $state, $fb, $text) {

    $scope.$text = $text;
    const $ctrl = this;

    $ctrl.views = [
        {
            view: 'dados',
            icon: 'ph-clipboard-text',
            title: $text.account.myProfile
        },
        {
            view: 'endereco',
            icon: 'ph-map-pin-line',
            title: $text.account.address
        },
        {
            view: 'faturas',
            icon: 'ph-wallet',
            title: $text.account.myBilling
        }
    ]

    $ctrl.usuarioLogout = () => {
        $fb.auth.logout().then(() => {
            $state.go('login');
        })
    };

    $ctrl.isView = (view) => {
        return $state.params.view == view;
    }

    $ctrl.baseUsuario = null;

    $ctrl.onUsuarioUpdate = () => {
        const idUsuario = $fb.auth.getIdToken().claims.idUsuario;
        $fb.db.get(`/cad_usuarios/${idUsuario}`).then(res => {
            $ctrl.baseUsuario = res;
        })
    }

    $ctrl.$onInit = () => {

        $ctrl.deregisterOnUsuarioUpdated = $scope.$on('update-usuario', $ctrl.onUsuarioUpdate);

        const idUsuario = $fb.auth.getIdToken().claims.idUsuario;
        $fb.db.get(`/cad_usuarios/${idUsuario}`).then(res => {
            $ctrl.baseUsuario = res;
        }).finally(() => {
            $state.params.showGlobalLoading = false;
        })
    }
}]);